var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticStyle: { position: "absolute", right: "1rem", top: "4rem" },
          attrs: {
            loading: _vm.downloadLoading,
            size: "small",
            type: "warning",
            icon: "el-icon-document"
          },
          on: {
            click: function($event) {
              return _vm.exportExcel(_vm.excelSheets, "便利店销售额总报")
            }
          }
        },
        [_vm._v(" 下载 ")]
      ),
      _c(
        "el-table",
        {
          ref: "tableShop",
          attrs: {
            id: "tableShop",
            data: _vm.groupData,
            "highlight-current-row": "",
            height: "700",
            "show-summary": "",
            "cell-style": _vm.cellStyle,
            "header-cell-style": { "text-align": "center" },
            border: ""
          },
          on: { "filter-change": _vm.filterChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              label: _vm.selectedArea,
              align: "center",
              "column-key": "area",
              filters: _vm.filterMapping,
              "filter-multiple": false,
              "filter-placement": "right",
              "filter-method": _vm.filterHandler
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.sellerName(scope.row.sellerId)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label:
                  "日期：" +
                  _vm.timestamp2datestring(_vm.start / 1000) +
                  " ~ " +
                  _vm.timestamp2datestring(_vm.end / 1000) +
                  "（按自然日）",
                align: "center"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "商品/元",
                  sortable: "",
                  align: "center",
                  prop: "afterAmountGoods"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "烟/元",
                  sortable: "",
                  align: "center",
                  prop: "afterAmountCigarette"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "礼包/元",
                  sortable: "",
                  align: "center",
                  prop: "afterAmountGiftPack"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "合计/元",
                  sortable: "",
                  align: "center",
                  prop: "afterAmount"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            {
              attrs: {
                label:
                  "月份：" +
                  _vm.timestamp2datestring(_vm.end / 1000, "YYYY年MM月") +
                  "（按交班日）",
                align: "center"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "商品/元",
                  sortable: "",
                  align: "center",
                  prop: "beforeAmountGoods"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "烟/元",
                  sortable: "",
                  align: "center",
                  prop: "beforeAmountCigarette"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "礼包/元",
                  sortable: "",
                  align: "center",
                  prop: "beforeAmountGiftPack"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "合计/元",
                  sortable: "",
                  align: "center",
                  prop: "beforeAmount"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }